import React, { useState, useEffect } from 'react';
import { useAppContext } from '../context/AppContext';  
import SideMenu from "../components/SideMenu";
import Profile from "../components/Profile";
import SchedulePage from "./SchedulePage";
import Chat from "../components/Chat";
import LeaderPanel from "../components/LeaderPanel";
import AdminPanel from "../components/AdminPanel";
import "./css/homepage.css";
import axios from 'axios';
import config from "../config";

const HomePage = () => {
  const { weekType, currentClass, nextClass, timeUntilNextClass } = useAppContext();
  const [activePage, setActivePage] = useState("home"); 
  const [groupId, setGroupId] = useState(null);
  const [userId, setUserId] = useState(null);
  const [username, setUsername] = useState("");
  const [todayClasses, setTodayClasses] = useState([]);
  const [isTomorrow, setIsTomorrow] = useState(false); // переключатель на завтра

  useEffect(() => {
    const fetchUserInfoAndSchedule = async () => {
      const token = localStorage.getItem("token");
      if (!token) return;

      try {
        const response = await axios.get(`${config.API_URL}/user_info`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUserId(response.data.user_id);
        setUsername(response.data.username);
        setGroupId(response.data.group_id);

        const sched = await axios.get(`${config.API_URL}/schedule`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const now = new Date();
        const jsDay = now.getDay();
        const weekday = jsDay === 0 ? 7 : jsDay;

        const currentMinutes = now.getHours() * 60 + now.getMinutes();

        const lessonsToday = sched.data
          .filter((lesson) => lesson.weekday === weekday)
          .sort((a, b) => a.order - b.order);

        const todayFiltered = [];
        for (let i = 1; i <= 8; i++) {
          const sameOrder = lessonsToday.filter((l) => l.order === i);
          if (sameOrder.length === 0) continue;

          const matchThisWeek = sameOrder.find(
            (l) => (weekType === "Числитель" ? l.is_even_week : !l.is_even_week)
          );
          const fallback = sameOrder[0];

          if (matchThisWeek) todayFiltered.push(matchThisWeek);
          else todayFiltered.push(fallback);
        }

        const lastLessonEnd = todayFiltered.length
          ? Math.max(
              ...todayFiltered.map((lesson) => {
                const [h, m] = lesson.end_time.split(":").map(Number);
                return h * 60 + m;
              })
            )
          : 0;

        if (todayFiltered.length === 0 || currentMinutes >= lastLessonEnd) {
          let tomorrowDay = weekday + 1;
          if (tomorrowDay > 7) tomorrowDay = 1;

          const tomorrowDate = new Date();
          tomorrowDate.setDate(now.getDate() + 1);
          const tomorrowWeekNum = getWeekNumber(tomorrowDate);
          const tomorrowType = tomorrowWeekNum % 2 === 0 ? "Числитель" : "Знаменатель";

          const lessonsTomorrow = sched.data
            .filter((lesson) => lesson.weekday === tomorrowDay)
            .sort((a, b) => a.order - b.order);

          const tomorrowFiltered = [];
          for (let i = 1; i <= 8; i++) {
            const sameOrder = lessonsTomorrow.filter((l) => l.order === i);
            if (sameOrder.length === 0) continue;

            const matchThisWeek = sameOrder.find(
              (l) => (tomorrowType === "Числитель" ? l.is_even_week : !l.is_even_week)
            );
            const fallback = sameOrder[0];

            if (matchThisWeek) tomorrowFiltered.push(matchThisWeek);
            else tomorrowFiltered.push(fallback);
          }

          if (tomorrowFiltered.length > 0) {
            setTodayClasses(tomorrowFiltered);
            setIsTomorrow(true);
          } else {
            setTodayClasses([]);
            setIsTomorrow(true);
          }
        } else {
          setTodayClasses(todayFiltered);
          setIsTomorrow(false);
        }
      } catch (error) {
        console.error("Ошибка загрузки информации о пользователе или расписания:", error);
      }
    };

    const getWeekNumber = (date) => {
      const d = new Date(date);
      d.setHours(0, 0, 0, 0);
      d.setDate(d.getDate() + 4 - (d.getDay() || 7));
      const yearStart = new Date(d.getFullYear(), 0, 1);
      return Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
    };

    fetchUserInfoAndSchedule();
  }, [weekType]);


  return (
    <>
      <header className='header'>
        <SideMenu setActivePage={setActivePage} />
      </header>
      <main>
        {activePage === "home" && (
          <div id="main">
            <p className="sliding-secondary-text">Добро пожаловать на главную страницу!</p>
            <p className="sliding-secondary-text">Тип недели: {weekType}</p>
            <p className="sliding-secondary-text">{timeUntilNextClass}</p>

            {/* Таблица расписания */}
            {todayClasses.length > 0 ? (
              <div className="mainpage-schedule-table-container">
                <p className="sliding-secondary-text">
                  {isTomorrow ? "Пары на завтра" : "Пары на сегодня"}
                </p>
                <table className="mainpage-schedule-table">
                  <thead>
                    <tr>
                      <th>№</th>
                      <th>Предмет</th>
                      <th>Кабинет</th>
                      <th>Преподаватель</th>
                      <th>Время</th>
                    </tr>
                  </thead>
                  <tbody>
                    {todayClasses.map((lesson, index) => {
                      let rowClass = "";
                      if (currentClass && lesson.id === currentClass.id) rowClass = "mainpage-current-class";
                      else if (nextClass && lesson.id === nextClass.id) rowClass = "mainpage-next-class";

                      return (
                        <tr key={index} className={rowClass}>
                          <td>{lesson.order}</td>
                          <td>{lesson.subject}</td>
                          <td>{lesson.classroom}</td>
                          <td>{lesson.teacher}</td>
                          <td>{lesson.start_time} - {lesson.end_time}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="sliding-secondary-text">
                {isTomorrow ? "Завтра выходной" : "Сегодня пар нет"}
              </p>
            )}
          </div>
        )}
        {activePage === "profile" && <Profile />}
        {activePage === "schedule" && <SchedulePage />}
        {activePage === "chat" && <Chat groupId={groupId} userId={userId} username={username} />}
        {activePage === "admin" && <AdminPanel />} 
        {activePage === "leader" && <LeaderPanel />} 
      </main>
    </>
  );
};

export default HomePage;
